import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * The header every report page shares: a quiet link back to the index above the title, one line
 * on what the page answers, and the page's own actions on the right (below the title on phones).
 */
const ReportHeader = ({ title, description, actions, backTo = '/reports', backLabel = 'Back to reports' }) => (
  <Row className="mb-4 g-3 align-items-end">
    <Col xs={12} md>
      <Link to={backTo} className="d-inline-flex align-items-center gap-1 small text-muted mb-2">
        <ArrowLeft size={14} aria-hidden="true" />{backLabel}
      </Link>
      <h1>{title}</h1>
      {description && <p className="text-muted mb-0">{description}</p>}
    </Col>
    {actions && (
      <Col xs={12} md="auto" className="d-flex align-items-end flex-wrap gap-2">
        {actions}
      </Col>
    )}
  </Row>
);

export default ReportHeader;
